//JIRA LPPLWEBMOB-721
//GIELK - 17.10.2023 - Formularz został przerobiony aby strony Url.AC, Url.OC_VEHICLE, Url.OC_PROPERTY które pierwonie ładowały formularz obecnie kierowały na wysyłkę danych. Pierwotnie reCAPTCHA była na początku formularza przed załadowaniem pól, obecnie jest na końcu po podsumowaniu przed wysyłką danych.
import { FormType } from "../components/enums";
import {
  Applicant,
  Incident,
  Perpetrator,
  Preload as ACPreload,
  Summary as ACSummary,
  Vehicle,
} from "../features/AC";
import { selectUIData as selectACUIApplicantData } from "../features/AC/Applicant/applicant.selectors";
import { selectUIData as selectACUIIncidentData } from "../features/AC/Incident/incident.selectors";
import { selectUIData as selectACUIPerpetratorData } from "../features/AC/Perpetrator/perpetrator.selectors";
import { selectUIData as selectACUIVehicleData } from "../features/AC/Vehicle/vehicle.selectors";
import { ContactUs as OCPersonWelcome } from "../features/OC/Person";
import {
  Damages as OCPropertyDamages,
  Incident as OCPropertyIncident,
  Perpetrator as OCPropertyPerpetrator,
  Preload as OCPropertyPreload,
  Owner as OCPropertyOwner,
  Summary as OCPropertySummary,
} from "../features/OC/Property";
import { selectUIData as selectOCPropertyUIDamagesData } from "../features/OC/Property/Damages/damages.selectors";
import { selectUIData as selectOCPropertyUIIncidentData } from "../features/OC/Property/Incident/incident.selectors";
import { selectUIData as selectOCPropertyUIOwnerData } from "../features/OC/Property/Owner/owner.selectors";
import { selectUIData as selectOCPropertyUIPerpetratorData } from "../features/OC/Property/Perpetrator/perpetrator.selectors";
import {
  Introductory as OCVehicleIntroductory,
  Incident as OCVehicleIncident,
  VehicleOwner as OCVehicleOwner,
  Damages as OCDamages,
  Preload as OCVehiclePreload,
  Summary as OCVehicleSummary,
} from "../features/OC/Vehicle";
import { selectUIData as selectOCVehicleDamagesUIData } from "../features/OC/Vehicle/Damages/damages.selectors";
import { selectUIData as selectOCVehicleIncidentUIData } from "../features/OC/Vehicle/Incident/incident.selectors";
import { selectUIData as selectOCVehicleIntroductoryUIData } from "../features/OC/Vehicle/Introductory/introductory.selectors";
import { selectUIData as selectOCVehicleOwnerUIData } from "../features/OC/Vehicle/VehicleOwner/vehicleOwner.selectors";
import {
  SendingError,
  SendingProgress,
  SendingSuccess,
} from "../features/Sender";
import { Welcome } from "../features/Welcome";
import { selectIsFormValidated } from "../store/HOC/genericUI.selectors";
import {
  selectACFormData,
  selectOCPropertyFormData,
  selectOCVehicleFormData,
} from "../store/rootSelectors";

import { RouteType, Url } from "./enums";
import { Routes } from "./types";

export const routes: Routes = [
  {
    type: RouteType.MAIN_ROUTE,
    name: "Ekran początkowy",
    component: Welcome,
    path: Url.WELCOME,
  },
  {
    type: RouteType.MAIN_ROUTE,
    name: "Błąd wysyłania zgłoszenia",
    path: Url.SENDING_ERROR,
    component: SendingError,
  },
  {
    type: RouteType.MAIN_ROUTE,
    name: "Trwa wysyłanie zgłoszenia",
    path: Url.AC_SENDING,
    component: SendingProgress,
    props: { formDataSelector: selectACFormData },
  },
  {
    type: RouteType.MAIN_ROUTE,
    name: "Formularz wysłany",
    path: Url.AC_SENDING_SUCCESS,
    component: SendingSuccess,
  },
  {
    type: RouteType.MAIN_ROUTE,
    id: FormType.AC,
    name: "Rozpoczęcie procesu",
    path: Url.AC,
    component: ACPreload,
    routes: [
      {
        type: RouteType.MAIN_ROUTE,
        name: "Pojazd",
        path: Url.AC_VEHICLE,
        component: Vehicle,
        formValidatedSelector: selectIsFormValidated(selectACUIVehicleData),
      },
      {
        type: RouteType.MAIN_ROUTE,
        name: "Zgłaszający",
        path: Url.AC_APPLICANT,
        component: Applicant,
        formValidatedSelector: selectIsFormValidated(selectACUIApplicantData),
        routes: [
          {
            type: RouteType.SUB_ROUTE,
            name: "Dane zgłaszającego",
            path: Url.AC_APPLICANT_DATA,
          },
          {
            type: RouteType.SUB_ROUTE,
            name: "Dane kierującego",
            path: Url.AC_APPLICANT_DRIVER,
          },
          {
            type: RouteType.SUB_ROUTE,
            name: "Inni uczestnicy",
            path: Url.AC_APPLICANT_ADDITIONAL,
          },
        ],
      },
      {
        type: RouteType.MAIN_ROUTE,
        name: "Zdarzenie",
        path: Url.AC_INCIDENT,
        component: Incident,
        formValidatedSelector: selectIsFormValidated(selectACUIIncidentData),
        routes: [
          {
            type: RouteType.SUB_ROUTE,
            name: "Okoliczności zdarzenia",
            path: Url.AC_INCIDENT_CIRCUMSTANCES,
          },
          {
            type: RouteType.SUB_ROUTE,
            name: "Uszkodzenia pojazdu",
            path: Url.AC_INCIDENT_DAMAGES,
          },
          {
            type: RouteType.SUB_ROUTE,
            name: "Oświadczenia",
            path: Url.AC_INCIDENT_STATEMENTS,
          },
        ],
      },
      {
        type: RouteType.MAIN_ROUTE,
        name: "Sprawca",
        path: Url.AC_PERPETRATOR,
        component: Perpetrator,
        formValidatedSelector: selectIsFormValidated(selectACUIPerpetratorData),
      },
      {
        type: RouteType.MAIN_ROUTE,
        name: "Podsumowanie",
        path: Url.AC_SUMMARY,
        component: ACSummary,
        formValidatedSelector: selectIsFormValidated(selectACUIPerpetratorData),
      },
    ],
  },
  {
    type: RouteType.MAIN_ROUTE,
    name: "Trwa wysyłanie zgłoszenia",
    path: Url.OC_VEHICLE_SENDING,
    props: { formDataSelector: selectOCVehicleFormData },
    component: SendingProgress,
  },
  {
    type: RouteType.MAIN_ROUTE,
    name: "Formularz wysłany",
    path: Url.OC_VEHICLE_SENDING_SUCCESS,
    component: SendingSuccess,
  },
  {
    type: RouteType.MAIN_ROUTE,
    id: FormType.OC_VEHICLE,
    name: "Rozpoczęcie procesu - OC pojazdu",
    path: Url.OC_VEHICLE,
    component: OCVehiclePreload,
    routes: [
      {
        type: RouteType.MAIN_ROUTE,
        name: "Informacje wstępne",
        path: Url.OC_VEHICLE_INTRODUCTORY,
        component: OCVehicleIntroductory,
        formValidatedSelector: selectIsFormValidated(
          selectOCVehicleIntroductoryUIData
        ),
        routes: [
          {
            type: RouteType.SUB_ROUTE,
            name: "Sprawca",
            path: Url.OC_VEHICLE_INTRODUCTORY_PERPETRATOR,
          },
          {
            type: RouteType.SUB_ROUTE,
            name: "Zgłaszający",
            path: Url.OC_VEHICLE_INTRODUCTORY_APPLICANT,
          },
        ],
      },
      {
        type: RouteType.MAIN_ROUTE,
        name: "Zdarzenie",
        path: Url.OC_VEHICLE_INCIDENT,
        component: OCVehicleIncident,
        formValidatedSelector: selectIsFormValidated(
          selectOCVehicleIncidentUIData
        ),
        routes: [
          {
            type: RouteType.SUB_ROUTE,
            name: "Okoliczności",
            path: Url.OC_VEHICLE_INCIDENT_CIRCUMSTANCES,
          },
          {
            type: RouteType.SUB_ROUTE,
            name: "Oświadczenia",
            path: Url.OC_VEHICLE_INCIDENT_STATEMENTS,
          },
          {
            type: RouteType.SUB_ROUTE,
            name: "Inni uczestnicy",
            path: Url.OC_VEHICLE_INCIDENT_OTHER_PERSONS,
          },
          {
            type: RouteType.SUB_ROUTE,
            name: "Świadkowie",
            path: Url.OC_VEHICLE_INCIDENT_WITNESSES,
          },
        ],
      },
      {
        type: RouteType.MAIN_ROUTE,
        name: "Pojazd i właściciel",
        path: Url.OC_VEHICLE_VEHICLE_OWNER,
        component: OCVehicleOwner,
        formValidatedSelector: selectIsFormValidated(
          selectOCVehicleOwnerUIData
        ),
        routes: [
          {
            type: RouteType.SUB_ROUTE,
            name: "Dane pojazdu",
            path: Url.OC_VEHICLE_VEHICLE_OWNER_VEHICLE,
          },
          {
            type: RouteType.SUB_ROUTE,
            name: "Właściciel",
            path: Url.OC_VEHICLE_VEHICLE_OWNER,
          },
        ],
      },
      {
        type: RouteType.MAIN_ROUTE,
        name: "Uszkodzenia pojazdu",
        path: Url.OC_VEHICLE_DAMAGES,
        component: OCDamages,
        formValidatedSelector: selectIsFormValidated(
          selectOCVehicleDamagesUIData
        ),
        routes: [
          {
            type: RouteType.SUB_ROUTE,
            name: "Opis i zdjęcia",
            path: Url.OC_VEHICLE_DAMAGES_IMAGES_DESCRIPTION,
          },
          {
            type: RouteType.SUB_ROUTE,
            name: "Informacje dodatkowe",
            path: Url.OC_VEHICLE_DAMAGES_ADDITIONAL,
          },
        ],
      },
      {
        type: RouteType.MAIN_ROUTE,
        name: "Podsumowanie",
        path: Url.OC_VEHICLE_SUMMARY,
        component: OCVehicleSummary,
        formValidatedSelector: selectIsFormValidated(
          selectOCVehicleDamagesUIData
        ),
      },
    ],
  },
  {
    type: RouteType.MAIN_ROUTE,
    id: FormType.OC_PROPERTY,
    name: "Rozpoczęcie procesu - OC mienia",
    path: Url.OC_PROPERTY,
    component: OCPropertyPreload,
    routes: [
      {
        type: RouteType.MAIN_ROUTE,
        name: "Sprawca",
        path: Url.OC_PROPERTY_PERPETRATOR,
        component: OCPropertyPerpetrator,
        formValidatedSelector: selectIsFormValidated(
          selectOCPropertyUIPerpetratorData
        ),
      },
      {
        type: RouteType.MAIN_ROUTE,
        name: "Zdarzenie",
        path: Url.OC_PROPERTY_INCIDENT,
        component: OCPropertyIncident,
        formValidatedSelector: selectIsFormValidated(
          selectOCPropertyUIIncidentData
        ),
        routes: [
          {
            type: RouteType.SUB_ROUTE,
            name: "Okoliczności",
            path: Url.OC_PROPERTY_INCIDENT_CIRCUMSTANCES,
          },
          {
            type: RouteType.SUB_ROUTE,
            name: "Oświadczenia",
            path: Url.OC_PROPERTY_INCIDENT_STATEMENTS,
          },
          {
            type: RouteType.SUB_ROUTE,
            name: "Inni uczestnicy",
            path: Url.OC_PROPERTY_INCIDENT_OTHER_PERSONS,
          },
        ],
      },
      {
        type: RouteType.MAIN_ROUTE,
        name: "Właściciel",
        path: Url.OC_PROPERTY_OWNER,
        component: OCPropertyOwner,
        formValidatedSelector: selectIsFormValidated(
          selectOCPropertyUIOwnerData
        ),
      },
      {
        type: RouteType.MAIN_ROUTE,
        name: "Uszkodzenia",
        path: Url.OC_PROPERTY_DAMAGES,
        component: OCPropertyDamages,
        formValidatedSelector: selectIsFormValidated(
          selectOCPropertyUIDamagesData
        ),
      },
      {
        type: RouteType.MAIN_ROUTE,
        name: "Podsumowanie",
        path: Url.OC_PROPERTY_SUMMARY,
        component: OCPropertySummary,
        formValidatedSelector: selectIsFormValidated(
          selectOCPropertyUIDamagesData
        ),
      },
    ],
  },
  {
    type: RouteType.MAIN_ROUTE,
    name: "Trwa wysyłanie zgłoszenia",
    path: Url.OC_PROPERTY_SENDING,
    props: { formDataSelector: selectOCPropertyFormData },
    component: SendingProgress,
  },
  {
    type: RouteType.MAIN_ROUTE,
    name: "Formularz wysłany",
    path: Url.OC_PROPERTY_SENDING_SUCCESS,
    component: SendingSuccess,
  },
  {
    type: RouteType.MAIN_ROUTE,
    name: "Skontaktuj się z nami - Szkoda na osobie",
    path: Url.OC_PERSON,
    component: OCPersonWelcome,
  },
];
